module.exports = __webpack_public_path__ + "static/media/permission.a7ada229.svg";